import { useLayoutEffect, useState } from 'react';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { CellButton } from '$uikit';
import './Confirm.sass';
import { toastActions } from '$store/toast';
import { useDispatch } from 'react-redux';
import { useTranslator } from '$hooks';

export const Confirm = () => {
  const dispatch = useDispatch();
  const t = useTranslator();
  const [title, setTitle] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  useLayoutEffect(() => {
    addEventListener('showConfirm', handleShowConfirm);

    return () => {
      removeEventListener('showConfirm', handleShowConfirm);
    };
  }, []);

  const handleShowConfirm = (e) => {
    setTitle(e.detail);
    setIsVisible(true);

    dispatch(toastActions.hideToast());
  };

  const handleClose = () => {
    dispatchEvent(new CustomEvent('rejectConfirm'));
    setIsVisible(false);
  };

  const handleAccept = () => {
    dispatchEvent(new CustomEvent('acceptConfirm'));
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <BottomSheet className="Confirm" title={title} onClose={handleClose}>
      <div className="Confirm__content">
        <CellButton size="small" onClick={handleAccept}>
          {t('confirm_accept')}
        </CellButton>
        <CellButton size="small" onClick={handleClose}>
          {t('confirm_reject')}
        </CellButton>
      </div>
    </BottomSheet>
  );
};
